import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: translateY(-50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { Flex, Text, LinkButton, FeatureTile, styled } from "@catchoftheday/cg-components";
import currency from "currency.js";
import { ClubCatchHeader } from "../../../components/ClubCatchHeader";
import { jsx as ___EmotionJSX } from "@emotion/react";
var CTAButton = styled(LinkButton)(_templateObject());
export var PopupContent = function PopupContent(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
      isCCMember = _ref.isCCMember,
      isFlybuysLinked = _ref.isFlybuysLinked,
      clubCatchSavingAmount = _ref.clubCatchSavingAmount,
      flybuysPointBalance = _ref.flybuysPointBalance;
  var showClubCatchJoin = !isLoggedIn || !isCCMember;
  var showFlybuysLink = isLoggedIn && isCCMember && !isFlybuysLinked;
  var showSavings = isLoggedIn && isCCMember && isFlybuysLinked;

  var renderHeaderContent = function renderHeaderContent() {
    if (showClubCatchJoin) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
        textStyle: "h3",
        m: "0",
        textAlign: "center",
        textTransform: "uppercase"
      }, "Start your 30 day free trial!"), ___EmotionJSX(Text, {
        m: "0",
        textAlign: "center"
      }, "After your free trial, Club Catch is only", ___EmotionJSX("br", null), "$6.50/month. Cancel anytime."));
    } else if (showFlybuysLink) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
        textStyle: "h3",
        m: "0",
        textAlign: "center"
      }, "Deals, meet points"), ___EmotionJSX(Text, {
        m: "0",
        textAlign: "center"
      }, "Collect 2 flybuys points per $1 spent with Catch"));
    } else if (showSavings) {
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
        textStyle: "h3",
        m: "0",
        textAlign: "center"
      }, "You've saved $".concat(clubCatchSavingAmount ? currency(clubCatchSavingAmount).toString() : ""), ___EmotionJSX("br", null), "with Club Catch"), ___EmotionJSX(Text, {
        m: "0",
        textAlign: "center"
      }, "You have ".concat(flybuysPointBalance ? Number(flybuysPointBalance).toLocaleString() : "", " flybuys points!")));
    }

    return null;
  };

  return ___EmotionJSX(Flex, {
    width: "400px",
    flexDirection: "column",
    color: "typography.text",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.50)",
    bg: "white"
  }, ___EmotionJSX(ClubCatchHeader, null, renderHeaderContent()), ___EmotionJSX(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, showClubCatchJoin ? ___EmotionJSX(CTAButton, {
    block: false,
    mr: "0.875rem",
    sizeVariant: "sm",
    variant: "primary",
    href: "/club-catch",
    "data-tracking": "header-app-club-catch-join-club-catch"
  }, "Join Club Catch") : showFlybuysLink ? ___EmotionJSX(CTAButton, {
    block: false,
    mr: "0.875rem",
    sizeVariant: "sm",
    variant: "primary",
    textTransform: "none",
    href: "/rewards/flybuys/link",
    "data-tracking": "header-app-club-catch-link-flybuys"
  }, "LINK flybuys") : ___EmotionJSX(CTAButton, {
    block: false,
    mr: "0.875rem",
    sizeVariant: "sm",
    variant: "primary",
    href: "/shop/club-catch",
    "data-tracking": "header-app-club-catch-shop-club-catch-deals"
  }, "Shop Club Catch Deals"), ___EmotionJSX(Text, {
    textStyle: "h3",
    color: "brand.clubCatch",
    m: "0",
    lineHeight: "1"
  }, "Unlock amazing benefits"), ___EmotionJSX(Flex, {
    flexWrap: "wrap",
    width: "100%",
    p: "15px 15px 5px 15px"
  }, ___EmotionJSX(FeatureTile, {
    backgroundImage: "https://s.catch.com.au/assets/0000/0914/5f0e80df3d20f761820443.jpg"
  }, ___EmotionJSX(Text, {
    textStyle: "h4",
    m: "0",
    lineHeight: "1"
  }, "FREE SHIPPING"), ___EmotionJSX(Text, {
    textStyle: "h6",
    m: "0",
    fontWeight: "light"
  }, "for eligible orders")), ___EmotionJSX(FeatureTile, {
    backgroundImage: "https://s.catch.com.au/assets/0000/0914/5ea297a0a8a68547960934.jpg"
  }, ___EmotionJSX(Text, {
    textStyle: "h4",
    m: "0",
    lineHeight: "1"
  }, "$1 = 2 points", ___EmotionJSX("sup", null, "*")), ___EmotionJSX(Text, {
    textStyle: "h6",
    m: "0",
    fontWeight: "light"
  }, "Simply link your card")), ___EmotionJSX(FeatureTile, {
    backgroundImage: "https://s.catch.com.au/assets/0000/0914/5ea297966bc62116127288.jpg"
  }, ___EmotionJSX(Text, {
    textStyle: "h4",
    m: "0",
    lineHeight: "1"
  }, "EARLY ACCESS"), ___EmotionJSX(Text, {
    textStyle: "h6",
    m: "0",
    fontWeight: "light"
  }, "to new deals")), ___EmotionJSX(FeatureTile, {
    backgroundImage: "https://s.catch.com.au/assets/0000/0914/5ea2979291fd4492267070.jpg"
  }, ___EmotionJSX(Text, {
    textStyle: "h4",
    m: "0",
    lineHeight: "1"
  }, "UNLOCK DEALS"), ___EmotionJSX(Text, {
    textStyle: "h6",
    m: "0",
    fontWeight: "light"
  }, "at members only prices"))), ___EmotionJSX(Text, {
    textStyle: "small",
    m: "0",
    p: "5px 15px 15px 15px"
  }, ___EmotionJSX("sup", null, "*"), " Exclusions apply")));
};
export default PopupContent;